import React, { useEffect, useState } from "react";
import axios from "axios";
import { formatPhoneNumber, URL_API } from "../../utils/helper/helpers";
import { toast } from "react-toastify";
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import { Card, CardBody, CardHeader, Col, Container, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, H3, } from "../../AbstractElements";
import { useNavigate } from "react-router-dom";

interface User {
    email: string;
    firstname: string;
    id: string;
    name: string;
    phone: string;
    updated_at: string;
}

interface Password {
    actuel: string;
    password: string;
    password_confirmation: string;
    email?: string;
    id?: string;
}

interface Infos {
    firstname: string;
    name: string;
    email: string;
    telephone: string;
    id?: string;
}

interface Erreur {
    actuel?: string;
    password?: string;
    password_confirmation?: string;
    email?: string;
    name?: string;
    firstname?: string;
    adresse?: string;
    telephone?: string;
    id?: string;
}

const ProfileCard: React.FC = () => {
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false); // Gère l'état d'envoi
    const [user, setUser] = useState<User>({
        email: "",
        firstname: "",
        id: "",
        name: "",
        phone: "",
        updated_at: "",
    });

    const [password, setPassword] = useState<Password>({
        actuel: "",
        password: "",
        password_confirmation: "",
        email: "",
        id: ""
    });

    const [infos, setInfos] = useState<Infos>({
        firstname: "",
        name: "",
        email: "",
        telephone: "",
    });

    const [erreurPassword, setErreurPassword] = useState<Erreur>({});
    const [erreurInfos, setErreurInfos] = useState<Erreur>({});

    const [changePassword, setChangePassword] = useState(false);
    const [changeInfos, setChangeInfos] = useState(false);
    const [role, setRole] = useState([])

    const changeHandlerPassword = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setPassword({ ...password, [e.target.name]: e.target.value });
    };

    const changeHandlerInfos = ( e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setInfos({ ...infos, [e.target.name]: e.target.value });
    };

    const navigate = useNavigate()
    const logout = async (name: string) => {
        if (name === "Log Out") {
        const Token = JSON.parse(localStorage.getItem("login")!);

        if (Token == null) {
            toast.info("Aucun token trouvé. Veuillez vous reconnecter.");
            return;
        }
        try {
            const response = await axios.post(`${URL_API}/logout`, {}, {
            headers: {
                Authorization: `Bearer ${Token}`
            }
            });
            if (response.status === 200) {
            localStorage.removeItem("login");
            localStorage.removeItem("user");
            localStorage.removeItem("permissions")

            navigate(`${process.env.PUBLIC_URL}/login`);
            } else {
            toast.error(`Erreur lors de la déconnexion: ${response.statusText}`);
            }

        } catch (error: any) {
            const message = error.response?.data?.message || "Erreur de déconnexion";
            toast.info(message);
        }
        }
    };

    const submitChangePassword = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            if(password.password === password.password_confirmation){
                const token = JSON.parse(localStorage.getItem('login')!);

                const response = await axios.post(
                    `${URL_API}/user/password`,
                    password,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );
    
                if (response.data.status === 200) {
                    toast.success(response.data.message);
                    setPassword({ actuel: "", password: "", password_confirmation: "" });
                    setErreurPassword({});
                    logout('Log Out');
                } else if (response.data.status === 400) {
                    setErreurPassword(response.data.errors);
                    toast.warning(response.data.message);
                } else if (response.data.status === 401) {
                    toast.info(response.data.message);
                }
            }else{
                setErreurPassword({
                    password_confirmation: "La confirmation n'est pas identiques au nouvaux mot de passe"
                })
            }

            
        } catch (error) {
            toast.error("Une erreur est survenue.");
        }
    };

    const submitChangeInfos = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsSubmitting(true);
        try {
            const token = JSON.parse(localStorage.getItem('login')!);

            const response = await axios.post(
                
                `${URL_API}/user/update/profile`,
                infos,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            if (response.data.status === 200) {
                toast.success(response.data.message);
                setUser(response.data.user);
                setChangeInfos(false);
                setInfos({
                    firstname: "",
                    name: "",
                    email: "",
                    telephone: "",
                });
                setErreurInfos({});
                localStorage.setItem("user", JSON.stringify(response.data.user));
                const event = new Event("userUpdated");
                document.dispatchEvent(event);
            } else if (response.data.status === 400) {
                setErreurInfos(response.data.errors);
                toast.warning(response.data.message);
            } else if (response.data.status === 401) {
                toast.info(response.data.message);
            }
        } catch (error) {
            console.log(error)
            toast.error("Une erreur est survenue.");
        }
        setIsSubmitting(false);
    };

    const toggleFormsPassword = () => {
        setChangePassword((prev) => !prev);
        const storedUser = JSON.parse(localStorage.getItem('user')!);
        setPassword({
            email: storedUser.email || "",
            id: storedUser.id || "",
            actuel: "", 
            password: "", 
            password_confirmation: "" 
        })
        setErreurPassword({});
    };

    const toggleFormsInfos = () => {
        if (changeInfos) {
            setChangeInfos(false);
            setInfos({
                firstname: "",
                name: "",
                email: "",
                telephone: "",
            });
        } else {
            const storedUser = JSON.parse(localStorage.getItem('user')!);
            if (storedUser) {
                setChangeInfos(true);
                setInfos({
                    firstname: storedUser.firstname || "",
                    name: storedUser.name || "",
                    email: storedUser.email || "",
                    telephone: storedUser.phone || "",
                    id: storedUser.id || "",
                });
            }
        }
    };

    useEffect(() => {
        const storedUser = JSON.parse(localStorage.getItem("user")!);
        const permissione = JSON.parse(localStorage.getItem("permissions")!);
        setUser(storedUser);
        setRole(permissione);
    }, []);
    return (
        <div className="page-body">
            <Breadcrumbs mainTitle="Profile" parent="Gestions" />
            <Container fluid>
                <Row>
                    <Col sm='12' md='4'>
                        <Card>
                            <CardBody>
                            
                                    {/* <H2>Mon Profile</H2> */}
                                    <div className="mb-4 text-center">
                                        <H3>{user.firstname + ' ' + user.name}</H3>
                                        <p>{user.email}</p>
                                        <p>{formatPhoneNumber(user.phone)}</p>
                                    </div>
                                    <div>
                                        {changePassword ? (
                                            <form onSubmit={submitChangePassword} className="form">
                                                <Row>
                                                    <Col sm='12'>
                                                        <FormGroup>
                                                            <Input
                                                                placeholder="Entrer le mot de passe actuel"
                                                                name="actuel"
                                                                value={password.actuel}
                                                                onChange={changeHandlerPassword}
                                                                type="password"
                                                            />
                                                            {erreurPassword.actuel && (
                                                                <span className="text-danger">{erreurPassword.actuel}</span>
                                                            )}
                                                        </FormGroup>
                                                    </Col>
                                                    <Col sm='12'>
                                                        <FormGroup>
                                                            <Input
                                                                placeholder="Entrer le nouveau mot de passe"
                                                                name="password"
                                                                value={password.password}
                                                                onChange={changeHandlerPassword}
                                                                type="password"
                                                            />
                                                            {erreurPassword.password && (
                                                                <span className="text-danger">{erreurPassword.password}</span>
                                                            )}
                                                        </FormGroup>
                                                    </Col>
                                                    <Col sm='12'>
                                                        <FormGroup>
                                                            <Input
                                                                placeholder="Confirmer mot de passe"
                                                                name="password_confirmation"
                                                                value={password.password_confirmation}
                                                                onChange={changeHandlerPassword}
                                                                type="password"
                                                            />
                                                            {erreurPassword.password_confirmation && (
                                                                <span className="text-danger">{erreurPassword.password_confirmation}</span>
                                                            )}
                                                        </FormGroup>
                                                    </Col>
                                                    <Col sm='12'>
                                                        <div className="form-submit my-2">
                                                            <Row>
                                                                <Col sm='6'>
                                                                    <Btn color="light-success" className="w-100" type="submit" disabled={isSubmitting}>
                                                                        Changer
                                                                    </Btn>
                                                                </Col>
                                                                <Col sm='6'>
                                                                    <Btn color="light-danger" className="w-100" onClick={toggleFormsPassword}>
                                                                        Annuler
                                                                    </Btn>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </form>
                                        ) : (
                                        <Btn color="light-info" className="w-100" onClick={toggleFormsPassword}>
                                            Modifier mon mot de passe
                                        </Btn>
                                        )}
                                    </div>

                            </CardBody>
                        </Card>
                        <Card>
                            <CardHeader>
                                <H3>Permissions</H3>
                            </CardHeader>
                            <CardBody>
                                {role.map((item, i) => (
                                    <Label className="mx-1 text-capitalize" for={`checkbox-primary${i}`} check key={i}>
                                        <Input
                                            className={`checkbox-primary checkbox-border-primary`}
                                            id={`checkbox-primary${i}`}
                                            type="checkbox"
                                            checked
                                        />
                                        {item}
                                    </Label>
                                ))}
                            </CardBody>
                        </Card>
                    </Col>
                    <Col sm='12' md='8'>
                        <Card>
                            <CardBody>
                            {changeInfos ? (
                                <form onSubmit={submitChangeInfos} className="form">
                                    <div className="row">
                                        <div className="col-lg-6 col-md-6 col-12">
                                            <FormGroup>
                                                <Input
                                                value={infos.firstname}
                                                onChange={changeHandlerInfos}
                                                type="text"
                                                name="firstname"
                                                placeholder="Prénoms"
                                                />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-12">
                                            <FormGroup>
                                                <Input
                                                value={infos.name}
                                                onChange={changeHandlerInfos}
                                                type="text"
                                                name="name"
                                                placeholder="Nom"
                                                />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-12">
                                            <FormGroup>
                                                <Input
                                                value={infos.email}
                                                onChange={changeHandlerInfos}
                                                type="email"
                                                name="email"
                                                placeholder="Email"
                                                disabled
                                                />
                                            </FormGroup>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-12">
                                            <FormGroup>
                                                <Input
                                                value={infos.telephone}
                                                onChange={changeHandlerInfos}
                                                type="text"
                                                name="telephone"
                                                placeholder="Téléphone"
                                                />
                                            </FormGroup>
                                        </div>
                                    </div>
                                    <div className="form-submit my-2">
                                    <Col sm='12'>
                                        <div className="form-submit my-2">
                                            <Row>
                                                <Col sm='6'>
                                                    <Btn color="light-success" className="w-100" type="submit" disabled={isSubmitting}>
                                                        Sauvegarder
                                                    </Btn>
                                                </Col>
                                                <Col sm='6'>
                                                    <Btn color="light-danger" className="w-100" onClick={toggleFormsInfos}>
                                                        Annuler
                                                    </Btn>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                    </div>
                                </form>
                                ) : (
                                    <>
                                        <Btn color="light-dark" className="w-100 for-light" onClick={toggleFormsInfos}>
                                            Modifier Mes Informations
                                        </Btn>
                                        <Btn color="light-light" className="w-100 for-dark" onClick={toggleFormsInfos}>
                                            Modifier Mes Informations
                                        </Btn>
                                    </>
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default ProfileCard;
